export enum HotelTabs {
    Tours = 'tours',
    Services = 'services',
    OnMap = 'on-map',
    Reviews = 'reviews',
}

export enum HotelReviewTab {
    TopHotels = 'topHotels',
    TripAdvisor = 'tripAdvisor',
    Sletat = 'sletat',
    TourPravda = 'tourPravda',
}
